<div class="page-title-area">
    <div class="container">
      <div class="page-title-content">
        <h2>Software Integration</h2>
        <ul>
          <li><a routerLink="/services">Services</a></li>
          <li>Software Integration</li>
        </ul>
      </div>
    </div>
  </div>